import React, { useState, useEffect } from "react";
import todoApi from "../../api/todoApi";

const TodoDetail = ({ task, onUpdated }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    due_date: "",
    tags: "",
  });

  useEffect(() => {
    if (task) {
      setFormData({
        title: task.title,
        description: task.description || "",
        due_date: task.due_date || "",
        tags: (task.tags || []).join(", "),
      });
    }
  }, [task]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleUpdate = async () => {
    try {
      const tagList =
        formData.tags.trim() !== ""
          ? formData.tags.split(",").map((tag) => tag.trim())
          : [];

      await todoApi.patch(`/api/todo/tasks/${task.id}/`, {
        title: formData.title,
        description: formData.description,
        due_date: formData.due_date === "" ? null : formData.due_date,
        tags: tagList,
      });

      alert("수정되었습니다.");
      onUpdated?.(); // ✅ 부모에게 갱신 요청
    } catch (err) {
      console.error("수정 실패:", err);
      alert("수정 실패");
    }
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-4">🛠 작업 수정</h2>

      <div className="mb-3">
        <label className="block text-sm text-gray-600 mb-1">제목</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded-md"
        />
      </div>

      <div className="mb-3">
        <label className="block text-sm text-gray-600 mb-1">설명</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          rows="3"
          className="w-full px-3 py-2 border rounded-md"
        />
      </div>

      <div className="mb-3">
        <label className="block text-sm text-gray-600 mb-1">마감일</label>
        <input
          type="date"
          name="due_date"
          value={formData.due_date || ""}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded-md"
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm text-gray-600 mb-1">태그 (쉼표로 구분)</label>
        <input
          type="text"
          name="tags"
          value={formData.tags}
          onChange={handleChange}
          className="w-full px-3 py-2 border rounded-md"
        />
      </div>

      <div className="flex justify-end">
        <button
          onClick={handleUpdate}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          💾 저장
        </button>
      </div>
    </div>
  );
};

export default TodoDetail;
